var _mask, _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButton432Disabled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 432,
    height: 91,
    viewBox: "0 0 432 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_bow_button_432",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 12,
    width: 421,
    height: 79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7986 14.1679C75.2884 16.2015 356.09 14.5376 383.6 13.0586C405.952 11.9494 413.785 13.4284 418.561 31.916C421.236 42.2691 419.708 65.9333 417.797 73.6981C415.505 82.3873 408.436 90.337 388.376 89.9672C370.227 89.5975 83.1213 89.4126 35.933 90.7067C3.83725 91.816 3.45516 80.5385 1.73574 74.0678C0.0163301 67.5972 -0.938899 41.3447 1.35365 33.7648C7.27607 15.6469 25.9986 13.4284 38.7986 14.1679Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_bow_button_432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7986 14.1679C75.2884 16.2015 356.09 14.5376 383.6 13.0586C405.952 11.9494 413.785 13.4284 418.561 31.916C421.236 42.2691 419.708 65.9333 417.797 73.6981C415.505 82.3873 408.436 90.337 388.376 89.9672C370.227 89.5975 83.1213 89.4126 35.933 90.7067C3.83725 91.816 3.45516 80.5385 1.73574 74.0678C0.0163301 67.5972 -0.938899 41.3447 1.35365 33.7648C7.27607 15.6469 25.9986 13.4284 38.7986 14.1679Z",
    fill: "url(#paint0_linear_bow_button_432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 52.6016L39.9977 13.4754C47.6484 13.8365 63.2675 14.0741 83.8223 14.2122L9.45193 86.9622C3.96599 83.7127 2.89795 79.179 2.05119 75.5846C1.93845 75.106 1.82964 74.6441 1.71484 74.2041C0.804981 70.7167 0.109847 61.568 0 52.6016Z",
    fill: "url(#paint1_linear_bow_button_432)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7034 90.5004C65.0066 90.631 49.2188 90.7956 39.6149 91L117.975 14.3476C131.928 14.3727 146.97 14.3699 162.557 14.3435L84.7034 90.5004Z",
    fill: "url(#paint2_linear_bow_button_432)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.902 90.1774C148.34 90.2143 133.263 90.2613 119.179 90.3196L196.941 14.2513C211.888 14.1973 226.965 14.1256 241.736 14.0397L163.902 90.1774Z",
    fill: "url(#paint3_linear_bow_button_432)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.88 90.0707C228.178 90.0774 213.168 90.091 198.259 90.1125L276.262 13.8089C292.344 13.6867 307.563 13.5494 321.256 13.4022L242.88 90.0707Z",
    fill: "url(#paint4_linear_bow_button_432)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.718 90.1005C308.098 90.0826 293.048 90.0709 277.174 90.067L356.005 12.9537C369.822 12.7337 379.62 12.5047 383.726 12.2799C390.864 11.9192 396.516 11.8281 401.058 12.4885L321.718 90.1005Z",
    fill: "url(#paint5_linear_bow_button_432)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.672 89.0382C398.066 89.9596 393.719 90.4402 388.485 90.342C385.257 90.275 373.442 90.214 355.941 90.1664L418.031 29.4287C418.214 30.0699 418.392 30.7334 418.567 31.4201C421.154 41.6199 419.795 64.5487 417.972 73.0936L401.672 89.0382Z",
    fill: "url(#paint6_linear_bow_button_432)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 18.7828C220 15.4691 222.686 12.7828 226 12.7828H414C417.313 12.7828 420 15.4691 420 18.7828V84.7828C420 88.0965 417.313 90.7828 414 90.7828H226C222.686 90.7828 220 88.0965 220 84.7828V18.7828Z",
    fill: "url(#paint7_linear_bow_button_432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.521 24.7195C12.172 26.7176 11.882 30.5322 12.027 31.8037C12.172 33.0752 14.6364 33.2569 18.1156 32.5303C21.5948 31.8037 23.9143 30.1689 23.1894 27.4442C22.3196 23.448 19.1304 23.6296 16.521 24.7195ZM26.0888 28.1708C26.8136 21.6315 29.8579 21.2682 42.1801 23.2663C56.3868 25.6277 61.6056 25.4461 61.7506 26.7176C62.0405 28.8974 54.2123 29.079 44.6445 29.079C35.0767 29.079 25.7988 30.5322 26.0888 28.1708Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_bow_button_432",
    x1: 211.986,
    y1: 12.7829,
    x2: 212.012,
    y2: 90.7829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACC7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#738CA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_bow_button_432",
    x1: -25.5866,
    y1: -1.02185,
    x2: -25.5866,
    y2: 90.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_bow_button_432",
    x1: -25.5866,
    y1: -1.02185,
    x2: -25.5866,
    y2: 90.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_bow_button_432",
    x1: -25.5866,
    y1: -1.02185,
    x2: -25.5866,
    y2: 90.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_bow_button_432",
    x1: -25.5866,
    y1: -1.02185,
    x2: -25.5866,
    y2: 90.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_bow_button_432",
    x1: -25.5866,
    y1: -1.02185,
    x2: -25.5866,
    y2: 90.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_bow_button_432",
    x1: -25.5866,
    y1: -1.02185,
    x2: -25.5866,
    y2: 90.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_bow_button_432",
    x1: 410.198,
    y1: 8.07596,
    x2: 309.77,
    y2: 75.6521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C7895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C7895",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton432Disabled);
export default __webpack_public_path__ + "static/media/button-432-disabled.6284d498.svg";
export { ForwardRef as ReactComponent };